export class DatePickerComponent {

    private _currentContext: JQuery = null;
    private _datepicker: JQuery = null;
    private _datepickerHidden: JQuery = null;
    private _button: JQuery = null;

    private bindEvents(): void {
        this._button.on("click", () => {
            this._datepicker.datepicker("show");
        });
        this._datepicker.on("changeDate", () => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const value = this._datepicker.datepicker("getDate") as Date;
            this._datepickerHidden.val(this.getFormattedDate(value));
        });
    }

    private getFormattedDate(date: Date): string {
        const month = date.getMonth() + 1;
        const day = date.getDate();

        const monthString = (month >= 10) ? month.toString() : `0${month}`;
        const dayString = (day >= 10) ? day.toString() : `0${day}`;
        const yearString = date.getFullYear().toString();

        return `${yearString}-${monthString}-${dayString}`;
    }

    private parseContext(): void {
        this._button = $(".js-pcg-datepicker__button", this._currentContext);
        this._datepicker = $(".js-pcg-datepicker", this._currentContext);
        this._datepickerHidden = $(".js-pcg-datepicker__hidden", this._currentContext);
    }

    public init(context: JQuery, options: DatepickerOptions): void {
        this._currentContext = context || this._currentContext;

        this.parseContext();
        this._datepicker.datepicker(options);
        this.bindEvents();
    }

    public static init(context: JQuery, options: DatepickerOptions): DatePickerComponent {
        const component = new DatePickerComponent();
        component.init(context, options);
        return component;
    }
}
